module.exports = __webpack_public_path__ + "img/profits.5d12cb8c.png";